interface MinimalPriceData {
  minimalPrice: string | number;
  currency: string | undefined;
  previousPrice: number | undefined;
}

interface IProps {
  price: string | number;
  largeWholesalePrice?: string | number;
  wholesalePrice?: string | number;
  oldPrice: number | undefined;
  oldWholesalePrice: number | undefined;
  oldLargeWholesalePrice: number | undefined;
  largeWholesalePriceCurrency: string | undefined;
  wholesalePriceCurrency: string | undefined;
}

const useMinimalPrice = ({
  largeWholesalePrice,
  wholesalePrice,
  price,
  oldPrice,
  oldWholesalePrice,
  oldLargeWholesalePrice,
  largeWholesalePriceCurrency,
  wholesalePriceCurrency,
}: IProps): MinimalPriceData => {
  if (largeWholesalePrice) {
    return {
      minimalPrice: largeWholesalePrice,
      currency: largeWholesalePriceCurrency,
      previousPrice: oldLargeWholesalePrice,
    };
  } else if (wholesalePrice) {
    return {
      minimalPrice: wholesalePrice,
      currency: wholesalePriceCurrency,
      previousPrice: oldWholesalePrice,
    };
  }

  return { minimalPrice: price, currency: undefined, previousPrice: oldPrice };
};

export default useMinimalPrice;
